import { render, staticRenderFns } from "./RectangleIcon.vue?vue&type=template&id=061a3863"
import script from "./RectangleIcon.vue?vue&type=script&lang=ts"
export * from "./RectangleIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports